import { CORPORATE_PAGE_FEATURES } from '../config/corporateNav';
import { formatCorporatePageLabel } from './corporatePageAccess';
import {
  INTELLIGENCE_NAV_ITEMS,
  METHODOLOGY_NAV_ITEM,
  PLATFORM_NAV_ITEMS,
  PREDICTION_NAV_ITEMS,
} from '../config/platformNav';
import { FEATURE_BY_PATH } from './featureAccess';
import { formatPlanFeatureLabel } from './planFeatureLabels';

/** All platform pages SuperAdmin can enable per registration type. */
export const CRITICAL_MINERALS_PAGE_FEATURES = [
  'page:overview',
  'page:supply-markets',
  'page:partners-risk',
  'page:policy-intelligence',
  // 'page:global-resource-sentinel',
  // 'page:geoeconomic-ai',
  'page:global-competitiveness',
  'page:methodology',
  'page:predictive-alerts',
  'page:crisis-simulator',
  // 'page:company-risk-dashboard',
];

export const EV_PAGE_FEATURES = ['page:ev-dashboard', 'page:ev-crisis-simulator'];

export const ALL_TOGGLEABLE_PAGE_FEATURES = [
  ...CRITICAL_MINERALS_PAGE_FEATURES,
  ...EV_PAGE_FEATURES,
];

/** Pages SuperAdmin can toggle per registration type. */
export const TOGGLEABLE_FEATURES_BY_REGISTRATION_TYPE = {
  corporate: [...CORPORATE_PAGE_FEATURES, ...EV_PAGE_FEATURES],
  policy_maker: ALL_TOGGLEABLE_PAGE_FEATURES,
};

export const CORPORATE_EV_PAGE_FEATURES = EV_PAGE_FEATURES;

export function toggleableFeaturesForRegistrationType(registrationType) {
  return TOGGLEABLE_FEATURES_BY_REGISTRATION_TYPE[registrationType] || [];
}

export function hasToggleablePageAccess(registrationType) {
  return toggleableFeaturesForRegistrationType(registrationType).length > 0;
}

export function isCorporateRegistrationType(registrationType) {
  return registrationType === 'corporate';
}

const NAV_ITEMS_BY_FEATURE = new Map();
[...PLATFORM_NAV_ITEMS, ...INTELLIGENCE_NAV_ITEMS, ...PREDICTION_NAV_ITEMS, METHODOLOGY_NAV_ITEM].forEach(
  (item) => {
    const feature = FEATURE_BY_PATH[item.path];
    if (feature) NAV_ITEMS_BY_FEATURE.set(feature, item);
  },
);

export function featureToPageMeta(feature) {
  const nav = NAV_ITEMS_BY_FEATURE.get(feature);
  if (nav) {
    return { path: nav.path, label: nav.label, feature };
  }
  return { path: null, label: formatPlanFeatureLabel(feature), feature };
}

export function enabledPlatformPages(enabledFeatures) {
  const set = new Set((enabledFeatures || []).map((f) => String(f).toLowerCase()));
  return ALL_TOGGLEABLE_PAGE_FEATURES.filter((f) => set.has(f)).map(featureToPageMeta);
}

export const REGISTRATION_TYPE_PAGE_CONFIG = {
  corporate: {
    workspacePath: '/corporate/alerts',
    workspaceTitle: 'Corporate Command Centre',
    pageSectionTitle: 'Corporate pages',
    formatPageLabel: formatCorporatePageLabel,
  },
  policy_maker: {
    workspacePath: '/policy-makers/alerts',
    workspaceTitle: 'Policy Maker Workspace',
    pageSectionTitle: 'Critical minerals platform pages',
    formatPageLabel: null,
  },
};

export function getRegistrationTypePageConfig(registrationType) {
  return REGISTRATION_TYPE_PAGE_CONFIG[registrationType] || null;
}
